<div>
<db-booster-optimization-status [websiteId]="website?.id"
                                [websiteUrl]="website?.site_url"
                                [websiteCDNEnabled]="website?.cloudflareEnabled"
                                [frontEndMenu]="true"
                                [userSubscriptionType]="userSubscription?.type"
                                [maxOptimizedPagesLength]="userSubscription?.plan?.services?.speed_optimizer?.speed_optimizier_optimizable_pages_max_count?.parameter_value - 1"
                                [userSubscription]="userSubscription"
                                [testMode]="testMode" [testModeEnabled]="testModeEnabled" [testModeLoading]="testModeLoading"
                                [boosterMode]="boosterMode"
                                [adminActivateBoosterUrl]="website?.adminActivateBoosterUrl"
                                [websiteIsStaging]="website?.type !== 'live'"
                                [cacheEnabled]="cacheEnabled" [cachingStatus]="cachingStatus"
                                [canEnable]="canEnable"
                                [isHosted]="!!website?.domain_hash" [showIncognitoMode]="true"  [cdnIsActive]="cdnIsActive" class="mb20" >
</db-booster-optimization-status>
<db-new-version-tab *ngIf="!!website?.domain_hash && updateAvailable"></db-new-version-tab>
</div>
<!--<db-enable-cdn *ngIf="!website?.cloudflareEnabled && userSubscription && userSubscription.boosterProClient"
               [userSubscription]="userSubscription" [websiteId]="website?.id" [websiteSiteUrl]="website?.site_url"></db-enable-cdn>-->

<db-booster-page-score [websiteId]="website?.id" [websiteUrl]="website?.site_url" [websiteHosted]="!!website?.domain_hash"
                       [trialBoosterWithHosted]="trialBoosterWithHostedWebsite"
                       [userSubscription]="userSubscription"
                       [websiteScore]="website?.score"
                       [currentScoreDate]="scoreDate"
                       [companyName]="companyName"
                       class="mb20">
</db-booster-page-score>

